const monthsThai = [
  'ม.ค.',
  'ก.พ.',
  'มี.ค.',
  'เม.ย.',
  'พ.ค.',
  'มิ.ย.',
  'ก.ค.',
  'ส.ค.',
  'ก.ย.',
  'ต.ค.',
  'พ.ย.',
  'ธ.ค.',
];

export const formatThaiDate = (date: Date): string => {
  const day = date.getDate();
  const month = monthsThai[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};
